import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateInt][formControlName],[validateInt][formControl],[validateInt][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => IntValidatorDirective),
            multi: true,
        },
    ],
})
export class IntValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        if (control.value === null || control.value === '') {
            return null;
        }

        const regex = new RegExp(`^[0-9]+$`);

        return regex.test(control.value)
                ? null
                : {int: true};
    }
}
